import { doGetCall } from './config/rest';
import Cookies from 'js-cookie';

const countries = ["DZ","BH","EG","IR","IQ","IL","JO","KW","LB","LY","MA","OM","PS","QA","SA","SY","TN","TR","AE","YE"]

export function getGeolocation(){
    doGetCall('/wp-json/country/v1/geolocation')
    .then(response => {
        Cookies.set('geolocation', response);
        Cookies.set('mena-country', countries.includes(response));
    })
}